import { CardContent, Grid, Typography } from "@material-ui/core";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import React from "react";
import StorefrontIcon from "@mui/icons-material/Storefront";

interface devisionCardSuppliersCmpProps {
  id: number | undefined;
  title: string | undefined;
  logo: string | undefined;
  borderRadius?: string | undefined;
}

const DevisionCardSuppliersCmp = ({
  id,
  title,
  logo,
  borderRadius
}: devisionCardSuppliersCmpProps) => {
  return (
    <>
      <Card
        className="centerVertical"
        variant="outlined"
        sx={{
          boxShadow: 1,
          border: 1,
          borderColor: "#DAE0E4",
          borderRadius: borderRadius ? borderRadius : "6px !important",
        }}
        style={{
          height: "100px",
          width: "100%",
          backgroundColor: "#F6F8F9",
          display: "flex",
          justifyContent: "start",
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        <CardContent style={{ alignSelf: "center", paddingTop: "2em" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {logo === "" ? (
              <StorefrontIcon
                style={{
                  width: "75px",
                  height: "75px",
                  color: "#9a9e9e",
                  padding: "15px",
                }}
                className="suppliersCardImg"
              />
            ) : (
              <img
                className="suppliersCardImg"
                src={`data:image/png;base64,${logo}`}
                alt=""
              />
            )}
            <Typography
              style={{
                color: "#1D4A87",
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              {title}
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </>
  );
};

export default DevisionCardSuppliersCmp;
